<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-correct2`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="0" y1="0" x2="1" y2="1" id="svg_2fb0e0980a__b"><stop offset="0%" stop-color="#BAD8FF"/><stop offset="100%" stop-color="#FFF"/><stop offset="100%" stop-color="#FBFDFF"/></linearGradient><clipPath id="svg_2fb0e0980a__a"><rect width="20" height="20" rx="0"/></clipPath></defs><g clip-path="url(#svg_2fb0e0980a__a)"><circle cx="10" cy="10" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_2fb0e0980a__b)'" r="8"/><path d="M18.643,4C14.387,6.37717,11.3,9.378910000000001,9.907,10.88297L6.505,8.45481L5,9.55736L5.0419242,9.58906C7.1624300000000005,11.19227,9.11598,13.00508,10.873000000000001,15C12,12.5,15.087,8.03418,19,4.7584L18.643,4Z" :fill="useCurrentColor ? 'currentColor' : '#006CFF'" style="mix-blend-mode:passthrough"/></g></svg>
</template>
<script>

export default {
  name: 'IconCorrect2',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
